import { Redirect } from "wouter";
import ClarityOneLayout from "@/components/clarity-one/ClarityOneLayout";
import { ClarityOneSessionRecovery } from "@/components/clarity-one/ClarityOneSessionRecovery";
import { useClarityOneMeSession } from "@/lib/useClarityOneMeSession";
import { rootRedirectPath } from "@/lib/clarityOneSessionGate";
import { Loader2 } from "lucide-react";

/** `/` — unauthenticated visitors go to login; authenticated users go to home. */
export default function ClarityOneRootPage() {
  const { meQuery, sessionView, retry } = useClarityOneMeSession();
  const dest = rootRedirectPath({
    isLoading: meQuery.isLoading,
    isFetching: meQuery.isFetching,
    isError: meQuery.isError,
    isSuccess: meQuery.isSuccess,
    data: meQuery.data ?? null,
    timedOut: sessionView.kind === "recovery" && sessionView.reason === "timeout",
  });

  if (dest) {
    return <Redirect to={dest} />;
  }

  if (sessionView.kind === "recovery") {
    return (
      <ClarityOneLayout showNav={false}>
        <ClarityOneSessionRecovery
          reason={sessionView.reason}
          onRetry={retry}
          testId="clarity-one-root-recovery"
        />
      </ClarityOneLayout>
    );
  }

  return (
    <ClarityOneLayout showNav={false}>
      <div className="flex justify-center py-20" data-testid="clarity-one-root-loading">
        <Loader2 className="h-8 w-8 animate-spin text-[#C8A96A]" />
      </div>
    </ClarityOneLayout>
  );
}
